import isObject from "../../common-utils/object/isObject.util.js";
import augmentFunctionKeyUtil from "../../common-utils/object/augmentFunctionKey.util.js";
export const arrayAugmentFunctionKeyUtil = (arr, options) => {
    if (!arr)
        return arr;
    const recursiveMapArray = (innerArr) => innerArr.map((item) => {
        if (Array.isArray(item)) {
            return recursiveMapArray(item);
        }
        else if (isObject(item)) {
            return augmentFunctionKeyUtil(item, options);
        }
        else {
            return item;
        }
    });
    return recursiveMapArray(arr);
};
export default arrayAugmentFunctionKeyUtil;
